var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-message",class:{
    'max-height': _vm.lineNumber > 6,
    'max-width': _vm.maxwidth,
    'full-screen': _vm.fullscreen,
  }},[_c('i',{class:_vm.fullscreen ? 'el-icon-close' : 'iconfont icon-tubiao_chakangongyi',on:{"click":function($event){_vm.fullscreen = !_vm.fullscreen}}}),_c('pre',{staticClass:"lum-scrollbar",domProps:{"innerHTML":_vm._s(_vm.formatCode(_vm.code, _vm.lang))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }